
        // classnames-loader: automatically bind css-modules to classnames
        var classNames = require("!../../node_modules/classnames/bind.js");
        var locals = require("!!../../node_modules/style-loader/dist/index.js?{\"attributes\":{}}!../../node_modules/css-loader/index.js?{\"modules\":true,\"importLoaders\":1,\"localIdentName\":\"[hash:base64:8]\"}!../../node_modules/postcss-loader/lib/index.js!../../node_modules/less-loader/dist/index.js!./icons.less");
        var css = classNames.bind(locals);
        for (var style in locals) css[style] = locals[style];
        module.exports = css;
    


//////////////////
// WEBPACK FOOTER
// ./src/react-toolbox-redesign/icons.less
// module id = 1304
// module chunks = 1